export default {"src":"/_next/static/media/giftLogo.6167ca7e.svg","height":49,"width":61};